 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'



import findStageById from '../../utils/meetings/findStageById'
import fromStageIdToUrl from '../../utils/meetings/fromStageIdToUrl'
import getMeetingPathParams from '../../utils/meetings/getMeetingPathParams'
import makeNotificationToastKey from './makeNotificationToastKey'

graphql`
  fragment mapDiscussionMentionedToToast_notification on NotifyDiscussionMentioned {
    id
    author {
      id
      preferredName
    }
    meeting {
      id
      name
      phases {
        phaseType
        stages {
          id
        }
      }
      ...fromStageIdToUrl_meeting
    }
    discussion {
      id
      stage {
        __typename
        id
        ... on TeamPromptResponseStage {
          response {
            id
          }
        }
      }
    }
  }
`

const mapDiscussionMentionedToToast = (
  notification,
  {history}
) => {
  if (!notification) return null
  const {id: notificationId, meeting, author, discussion} = notification
  const authorName = author ? author.preferredName : 'Anonymous'
  const {id: meetingId, name: meetingName} = meeting
  const {stage} = discussion
  const {id: stageId, response} = _nullishCoalesce(stage, () => ( {}))

  const meetingPath = getMeetingPathParams()
  const notifStageRes = findStageById(meeting.phases, stageId)
  if (
    meetingPath.meetingId === meetingId &&
    (!stageId ||
      (_optionalChain([notifStageRes, 'optionalAccess', _ => _.stageIdx]) === meetingPath.stageIdx &&
        _optionalChain([notifStageRes, 'optionalAccess', _2 => _2.phase, 'access', _3 => _3.phaseType]) === meetingPath.phaseType))
  ) {
    // We're already in the relevant stage of the meeting, so don't pop toast.
    return null
  }

  const directUrl = stageId ? fromStageIdToUrl(stageId, meeting) : `/meet/${meetingId}`

  return {
    key: makeNotificationToastKey(notificationId),
    autoDismiss: 10,
    message: `${authorName} mentioned you in a discussion in ${meetingName}.`,
    action: {
      label: 'See the discussion',
      callback: () => {
        history.push(
          response ? `${directUrl}?responseId=${encodeURIComponent(response.id)}` : directUrl
        )
      }
    }
  }
}

export default mapDiscussionMentionedToToast
